document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('rf-overlay');
  var popup = document.getElementById('rf-location-popup');
  var closePopupBtn = document.getElementById('rf-close-popup');
  var openDesktopBtn = document.getElementById('rf-open-location');
  var openMobileBtn = document.getElementById('rf-open-location-mobile');
  var useLocationBtn = document.getElementById('rf-use-location');
  var pincodeForm = document.getElementById('rf-pincode-form');
  var pincodeInput = document.getElementById('rf-pincode');

  var deliveryTimeDesktop = document.getElementById('rf-delivery-time');
  var addressDesktop = document.getElementById('rf-address');
  var deliveryTimeMobile = document.getElementById('rf-delivery-time-m');
  var addressMobile = document.getElementById('rf-address-m');

  var allTabSets = document.querySelectorAll('.rf-tab[data-cat]');
  var allGroups = document.querySelectorAll('.rf-subcat-group[data-group]');

  var storageKey = 'rufftail_delivery_location_v2';
  var popupSeenKey = 'rufftail_location_popup_seen_v1';

  var warehouseLat = 18.461532044582736;
  var warehouseLon = 73.83619878732844;
  var puneServiceRadiusKm = 35;

  function setUI(timeText, addressText) {
    if (deliveryTimeDesktop) deliveryTimeDesktop.textContent = timeText;
    if (addressDesktop) addressDesktop.textContent = addressText;
    if (deliveryTimeMobile) deliveryTimeMobile.textContent = timeText;
    if (addressMobile) addressMobile.textContent = addressText;
  }

  function saveLocation(payload) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(payload));
      localStorage.setItem(popupSeenKey, 'yes');
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('rufftail:location-updated', { detail: payload }));
  }

  function getSavedDeliveryLocation() {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.time) return parsed;
    } catch (error) {}
    return null;
  }

  function getHeaderDeliveryLocation() {
    var timeText = deliveryTimeDesktop && deliveryTimeDesktop.textContent
      ? deliveryTimeDesktop.textContent
      : deliveryTimeMobile && deliveryTimeMobile.textContent
        ? deliveryTimeMobile.textContent
        : '';
    var addressText = addressDesktop && addressDesktop.textContent
      ? addressDesktop.textContent
      : addressMobile && addressMobile.textContent
        ? addressMobile.textContent
        : '';

    timeText = timeText.replace(/\s+/g, ' ').trim();
    addressText = addressText.replace(/\s+/g, ' ').trim();

    if (!timeText || /check delivery time|invalid pincode/i.test(timeText)) return null;

    return {
      time: timeText,
      address: addressText
    };
  }

  function syncCartDeliveryEta() {
    var targets = document.querySelectorAll('[data-rt-dynamic-eta]');
    var shortTargets = document.querySelectorAll('[data-rt-dynamic-eta-short]');
    var midMessages = document.querySelectorAll('[data-rt-delivery-mid-message]');
    var midNotes = document.querySelectorAll('[data-rt-delivery-mid-note]');
    var fastMessages = document.querySelectorAll('[data-rt-delivery-fast-message]');
    var feeLabels = document.querySelectorAll('[data-rt-delivery-fee-label]');
    if (!targets.length && !shortTargets.length && !midMessages.length && !midNotes.length && !fastMessages.length && !feeLabels.length) return;

    var saved = getSavedDeliveryLocation() || getHeaderDeliveryLocation();
    var timeText = saved && saved.time ? saved.time : '';
    var addressText = saved && saved.address ? saved.address : '';
    var standardEtaPattern = /\b(day|days)\b|pincode|india/i;
    var fastEtaPattern = /\b(min|mins|minute|minutes|hour|hours|hr|hrs)\b/i;
    var hasFastEta = fastEtaPattern.test(timeText) && !standardEtaPattern.test(timeText + ' ' + addressText);
    var etaText = timeText
      ? 'ETA: ' + timeText + (addressText ? ' for ' + addressText : ' from your selected location') + '.'
      : 'ETA depends on selected location or pincode.';
    var shortEtaText = timeText
      ? timeText + (addressText ? ' for ' + addressText : '')
      : '1-hour Pune delivery';
    var standardEtaText = timeText
      ? 'Delivery ETA: ' + shortEtaText + '.'
      : 'Delivery ETA depends on selected location or pincode.';

    targets.forEach(function (target) {
      target.textContent = etaText;
    });

    shortTargets.forEach(function (target) {
      target.textContent = shortEtaText;
    });

    midMessages.forEach(function (target) {
      var remaining = target.getAttribute('data-remaining') || '';
      target.textContent = hasFastEta
        ? 'Free delivery unlocked. Add ' + remaining + ' more for 1-hour Pune delivery.'
        : 'Free delivery unlocked.';
    });

    midNotes.forEach(function (target) {
      target.textContent = hasFastEta
        ? 'ETA: ' + shortEtaText + '.'
        : standardEtaText;
    });

    fastMessages.forEach(function (target) {
      target.textContent = hasFastEta
        ? '1-hour Pune delivery unlocked in selected serviceable areas.'
        : 'Free delivery unlocked.';
    });

    feeLabels.forEach(function (target) {
      target.textContent = hasFastEta ? '1-hour Pune delivery' : 'Free delivery';
    });
  }

  function restoreLocation() {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return false;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.time && parsed.address) {
        setUI(parsed.time, parsed.address);
        syncCartDeliveryEta();
        return true;
      }
    } catch (error) {}
    return false;
  }

  function openPopup() {
    if (popup) {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
    }
    if (overlay) {
      overlay.classList.add('is-open');
    }
    document.body.classList.add('rf-location-popup-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (popup) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.classList.remove('is-open');
    }
    document.body.classList.remove('rf-location-popup-open');
    document.body.style.overflow = '';
  }

  function attachOpen(el) {
    if (el) el.addEventListener('click', openPopup);
  }

  attachOpen(openDesktopBtn);
  attachOpen(openMobileBtn);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#rf-open-location, #rf-open-location-mobile, .rf-location-trigger');
    if (!trigger) return;
    event.preventDefault();
    openPopup();
  });

  if (closePopupBtn) closePopupBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  function toRad(value) {
    return value * Math.PI / 180;
  }

  function getDistanceKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function getPuneTime(km) {
    if (km <= 5) return '20-35 mins';
    if (km <= 10) return '35-50 mins';
    if (km <= 15) return '50-70 mins';
    if (km <= 22) return '70-90 mins';
    if (km <= 35) return '90-120 mins';
    return null;
  }

  function getNonPuneEstimate(city, fullAddress) {
    var combined = ((city || '') + ' ' + (fullAddress || '')).toLowerCase();

    if (combined.indexOf('mumbai') !== -1) return '3-4 days';
    if (combined.indexOf('hyderabad') !== -1) return '3-4 days';
    if (
      combined.indexOf('goa') !== -1 ||
      combined.indexOf('panaji') !== -1 ||
      combined.indexOf('margao') !== -1 ||
      combined.indexOf('vasco') !== -1
    ) return '3-4 days';
    if (
      combined.indexOf('bangalore') !== -1 ||
      combined.indexOf('bengaluru') !== -1
    ) return '4-5 days';
    if (
      combined.indexOf('new delhi') !== -1 ||
      combined.indexOf('delhi') !== -1 ||
      combined.indexOf('ncr') !== -1 ||
      combined.indexOf('gurgaon') !== -1 ||
      combined.indexOf('gurugram') !== -1 ||
      combined.indexOf('noida') !== -1
    ) return '4-5 days';

    return '4-6 days';
  }

  function normalizeAddress(addressObj) {
    var area =
      addressObj.neighbourhood ||
      addressObj.suburb ||
      addressObj.quarter ||
      addressObj.road ||
      addressObj.city_district ||
      addressObj.village ||
      addressObj.hamlet ||
      '';

    var city =
      addressObj.city ||
      addressObj.town ||
      addressObj.county ||
      addressObj.state_district ||
      addressObj.state ||
      '';

    var parts = [];
    if (area) parts.push(area);
    if (city) parts.push(city);

    return {
      area: area,
      city: city,
      fullAddress: parts.join(', ')
    };
  }

  function updateAndStore(timeText, addressText) {
    setUI(timeText, addressText);
    saveLocation({
      time: timeText,
      address: addressText
    });
    syncCartDeliveryEta();
  }

  function resolveLocation(lat, lon) {
    var km = getDistanceKm(lat, lon, warehouseLat, warehouseLon);
    var puneEta = getPuneTime(km);

    fetch(
      'https://nominatim.openstreetmap.org/reverse?format=json&lat=' +
        encodeURIComponent(lat) +
        '&lon=' +
        encodeURIComponent(lon) +
        '&addressdetails=1',
      {
        headers: {
          'Accept-Language': 'en'
        }
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var addressObj = (data && data.address) || {};
        var normalized = normalizeAddress(addressObj);
        var cityText = (normalized.city || '').toLowerCase();
        var addressText = normalized.fullAddress || 'Your location';

        var isPuneArea =
          km <= puneServiceRadiusKm ||
          cityText.indexOf('pune') !== -1 ||
          cityText.indexOf('pimpri') !== -1 ||
          cityText.indexOf('chinchwad') !== -1 ||
          cityText.indexOf('pcmc') !== -1 ||
          addressText.toLowerCase().indexOf('pune') !== -1 ||
          addressText.toLowerCase().indexOf('pimpri') !== -1 ||
          addressText.toLowerCase().indexOf('chinchwad') !== -1;

        if (isPuneArea && puneEta) {
          updateAndStore(puneEta, addressText);
        } else {
          updateAndStore(getNonPuneEstimate(normalized.city, addressText), addressText);
        }

        closePopup();
      })
      .catch(function () {
        if (puneEta) {
          updateAndStore(puneEta, 'Pune service area');
        } else {
          updateAndStore('4-6 days', 'India');
        }
        closePopup();
      });
  }

  if (useLocationBtn) {
    useLocationBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        setUI('Check delivery time', 'Geolocation not supported. Use pincode.');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          resolveLocation(position.coords.latitude, position.coords.longitude);
        },
        function () {
          setUI('Check delivery time', 'Location denied. Use pincode.');
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000
        }
      );
    });
  }

  function pincodeLogic(pin) {
    if (/^41\d{4}$/.test(pin)) {
      return {
        time: '20-120 mins',
        address: 'Pincode ' + pin + ', Pune'
      };
    }

    if (/^40\d{4}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Mumbai'
      };
    }

    if (/^50\d{4}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Hyderabad'
      };
    }

    if (/^40[34]\d{3}$/.test(pin)) {
      return {
        time: '3-4 days',
        address: 'Pincode ' + pin + ', Goa'
      };
    }

    if (/^56\d{4}$/.test(pin)) {
      return {
        time: '4-5 days',
        address: 'Pincode ' + pin + ', Bangalore'
      };
    }

    if (/^11\d{4}$/.test(pin) || /^12\d{4}$/.test(pin)) {
      return {
        time: '4-5 days',
        address: 'Pincode ' + pin + ', New Delhi'
      };
    }

    return {
      time: '4-6 days',
      address: 'Pincode ' + pin + ', India'
    };
  }

  if (pincodeForm) {
    pincodeForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var pin = (pincodeInput.value || '').trim();

      if (!/^\d{6}$/.test(pin)) {
        setUI('Invalid pincode', 'Enter a valid 6 digit pincode');
        return;
      }

      var result = pincodeLogic(pin);
      updateAndStore(result.time, result.address);
      closePopup();
    });
  }

  function setActiveCategory(cat) {
    allTabSets.forEach(function (tab) {
      if (tab.getAttribute('data-cat') === cat) {
        tab.classList.add('is-active');
      } else if (tab.hasAttribute('data-cat')) {
        tab.classList.remove('is-active');
      }
    });

    allGroups.forEach(function (group) {
      if (group.getAttribute('data-group') === cat) {
        group.classList.add('is-active');
      } else {
        group.classList.remove('is-active');
      }
    });
  }

  allTabSets.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.getAttribute('data-cat');
      if (cat) setActiveCategory(cat);
    });
  });

  function detectCurrentCategory() {
    var path = window.location.pathname.toLowerCase();

    if (path.indexOf('/collections/cat') !== -1 || path.indexOf('/collections/cats') !== -1) {
      setActiveCategory('cats');
      return;
    }

    if (path.indexOf('/collections/dog') !== -1 || path.indexOf('/collections/dogs') !== -1) {
      setActiveCategory('dogs');
      return;
    }

    setActiveCategory('all');
  }

  var hasSavedLocation = restoreLocation();
  var alreadySeenPopup = false;

  try {
    alreadySeenPopup = localStorage.getItem(popupSeenKey) === 'yes';
  } catch (error) {}

  function shouldSuppressAutoLocationPopup() {
    var path = window.location.pathname.toLowerCase();
    return path.indexOf('/pages/build-your-applaws-box') !== -1 || !!document.querySelector('[id^="RufftailApplawsBox-"]');
  }

  if (!hasSavedLocation && !alreadySeenPopup && !shouldSuppressAutoLocationPopup()) {
    setTimeout(function () {
      openPopup();
    }, 500);
  }

  detectCurrentCategory();
  syncCartDeliveryEta();
  document.addEventListener('rufftail:location-updated', syncCartDeliveryEta);
  document.addEventListener('cart:updated', syncCartDeliveryEta);
  document.addEventListener('shopify:section:load', syncCartDeliveryEta);
  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) {
      restoreLocation();
      syncCartDeliveryEta();
    }
  });

  var etaSyncTimer;
  function scheduleEtaSync() {
    window.clearTimeout(etaSyncTimer);
    etaSyncTimer = window.setTimeout(syncCartDeliveryEta, 80);
  }

  if (window.MutationObserver) {
    var cartEtaObserver = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        if (mutation.type !== 'childList') return false;
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          return (
            node.matches('[data-rt-dynamic-eta], [data-rt-dynamic-eta-short], [data-rt-delivery-mid-message], [data-rt-delivery-mid-note], [data-rt-delivery-fast-message], [data-rt-delivery-fee-label], cart-drawer, .cart-drawer, .rf-cart') ||
            node.querySelector('[data-rt-dynamic-eta], [data-rt-dynamic-eta-short], [data-rt-delivery-mid-message], [data-rt-delivery-mid-note], [data-rt-delivery-fast-message], [data-rt-delivery-fee-label]')
          );
        });
      });
      if (shouldSync) scheduleEtaSync();
    });
    cartEtaObserver.observe(document.body, { childList: true, subtree: true });
  }

  setTimeout(syncCartDeliveryEta, 250);
  setTimeout(syncCartDeliveryEta, 1000);
});
